import VueTour from "vue-tour/src/main";
import Vue from "vue";

require("vue-tour/dist/vue-tour.css");

const registry = Vue.observable({ steps: {} });

export default {
  install(Vue) {
    Vue.use(VueTour);
    Vue.directive("tour-step", stepDirective);
    Vue.prototype.$tours.registry = registry;
  },
};

const stepDirective = {
  bind(el, binding) {
    el.dataset.tourStep = binding.value;
  },
  inserted(el, binding) {
    Vue.set(registry.steps, binding.value, true);
  },
  unbind(el, binding) {
    Vue.set(registry.steps, binding.value, false);
  },
};
